import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRadiusBottomRight20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconRadiusBottomRight20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.988 16.488H6.504a.75.75 0 1 0 0 1.5h2.484a8.75 8.75 0 0 0 8.75-8.75v-2.48a.75.75 0 0 0-1.5 0v2.48a7.25 7.25 0 0 1-7.25 7.25m3.5-13.226a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-3.5 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-3.5 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-2.5 11a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-1-4.5a1 1 0 1 0 2 0 1 1 0 0 0-2 0m0-3.5a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRadiusBottomRight20);
